import React, { ReactNode } from "react";
import { BaseBotData, BotType, OrderTypes } from "@shared/types";
import ExtraInfoItem from "common/ExtraDetails/ExtraInfoItem";
import useBotStrategySummary from "features/bots/BotDrawer/useBotStrategySummary";

interface BotStrategySummaryProps {
  botData: BaseBotData;
  orderType: OrderTypes;
  isAdvanced?: boolean;
  pricePrecision?: number;
  isChannelConfiguration?: boolean;
  defaultTakeProfitDisplay?: ReactNode;
}

const BotStrategySummary = ({
  botData,
  orderType,
  isAdvanced,
  pricePrecision,
  isChannelConfiguration,
  defaultTakeProfitDisplay,
}: BotStrategySummaryProps) => {
  const parsedStrategySummary = useBotStrategySummary({
    botData,
    orderType,
    isAdvanced,
    pricePrecision,
    isChannelConfiguration,
  });

  if (!parsedStrategySummary) return null;

  const isSignalBots = botData.bot_type === BotType.SIGNAL;

  const items: ReactNode[] | undefined = parsedStrategySummary?.map((data) => {
    return (
      <ExtraInfoItem
        key={data.title}
        name={data.title}
        value={data.value}
        autoHeight={true}
        valueFlex={"0 0 50%"}
      />
    );
  });

  if (isSignalBots && defaultTakeProfitDisplay) {
    items?.splice(1, 0, defaultTakeProfitDisplay);
  }

  return <>{items}</>;
};

export default BotStrategySummary;
